<template lang="pug">
    .number(:class='color')
        .number__numeral-wrap(ref='animation')
            span.number__numeral(v-for='(item, itemIndex) in value.length', :key='itemIndex', v-html='value[item-1]',  ref='numeral')

        .number__text(v-html='text')

</template>

<script>
import {mixinAnimation} from './mixins/mixinAnimation';
import {gsap} from 'gsap';

export default {
    data() {
        return {
            timeline: null,
            instance: null,
            isInited: false
        };
    },
    props: {
        value: String,
        text: String,
        animated: Boolean,
        isActive: Boolean,
        color: String
    },
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            if (!this.animated) {
                return;
            }
            this.createTimeline();
            this.createScroll('bottom-bottom', 'top-middle');
        },
        createTimeline() {
            this.timeline = gsap.timeline();
            this.timeline.set(this.$refs.numeral, {y: '-140'}).to(this.$refs.numeral, {
                duration: 9,
                ease: 'power2.inOut',
                stagger: {each: 3},
                y: 0
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';

.number {
    font-family: var(--font-accent);
    font-weight: 800;
    color: inherit;
    overflow: hidden;
    width: 100%;
    &.black {
        color: var(--theme);
    }

    @media (--viewport-laptop) {
        width: calc(var(--grid-column-laptop) * 9);
    }

    @media (--viewport-tablet) {
        width: calc(var(--grid-column-mobile) * 11);
        padding-left: calc(var(--grid-column-mobile) * 1);
    }

    &__numeral {
        font-size: 7.8rem;
        line-height: 10.5rem;
        display: inline-block;

        @media (--viewport-tablet) {
            font-size: 6.55rem;
            line-height: 8.5rem;
        }
    }
    &__numeral-wrap {
        display: flex;
    }

    &__text {
        font-size: 1.25rem;
        line-height: 1.2;
        position: relative;
        padding-top: 25px;

        &::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            height: 0.25rem;
            width: 0.625rem;
            background-color: currentColor;
        }
    }
}
</style>
